import React from 'react'
import "./NotFoundPage.css"

import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
     const navigate = useNavigate();

     const onNavigateWarehouses = () => {
       navigate("/warehouses");
     };
  return (
    <div className="not-found-page-container">
      <div className="not-found-page-wrapper">
        <h1 className="not-found-page-heading">Page not found</h1>
        <button
          className="not-found-page-navigate-btn"
          onClick={onNavigateWarehouses}
        >
          Go to warehouses
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage